document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('template-product')) {
        var characterAmount = 0;

        $('#add_embroidery').on('change', function () {
            if ($(this).prop('checked')) {
                //$('#embroidery_wrapper').slideDown();
                $('#embroidery_field').attr('required', '');
            } else {
                //$('#embroidery_wrapper').slideUp();
                $('#embroidery_field').removeAttr('required');
            }
        });

        $('#embroidery_field').on('keyup', function (e) {
            if (characterAmount != e.target.value.length) {
                characterAmount = e.target.value.length;
                $('#bordado_select-option1').val(characterAmount);
                $('#bordado_select-option1').trigger('change');
            }
        });
      
        $('#embroidery_field').on('keypress', function() {
            var regex = new RegExp("^[a-zA-Z0-9-Zàèìòùáéíóúâêîôûãõ\b\?.,;!: ]+$");
                            
            var _this = this;
           
            setTimeout( function(){
                var texto = $(_this).val();
                if(!regex.test(texto))
                {
                    $(_this).val(texto.substring(0, (texto.length-1)))
                }
            }, 100);
        });

        $('#bordado_select-option1').on('change', function () {
            $('#hidden_option1[name=bordado-option1]').val($(this).val());
        });

        $('#embroidery_color li').on('click', function () {
            $('#embroidery_color li').removeClass('active');
            $(this).addClass('active');
            $('#hidden_option2[name=bordado-option2]').val($(this).attr('class').replace(' active', ''));
        });

        $('.custom_addToCart').on('click', function (event) {
            var btn = $(this);

            btn.addClass('buy-loading');
            if ($('#add_embroidery').prop('checked')) {
                var option1Value = $('#bordado_select-option1').val(),
                    option2Value = $('#hidden_option2[name=bordado-option2]').val(),
                    embroideryText = $('#embroidery_field').val(),
                    variant = '',
                    property = { 'Texto': embroideryText },
                    mainProduct = $('[cart-note]').attr('data-product'),
                    embroidery = mainProduct + ' / Bordado: ' + embroideryText,
                    cartNote = $('[cart-note]').attr('cart-note') != '' && !$('[cart-note]').attr('cart-note').replace(' -- ', '').includes(embroidery),
                    cartNotes = cartNote ? $('[cart-note]').attr('cart-note') + ' -- ' + embroidery : embroidery;

                if ($('#embroidery_field').val() != '') {
                    variant = parseInt($('#bordado_product_variant option[data-option1="' + option1Value + '"][data-option2="' + option2Value + '"]').attr('data-variant'));

                    if (!isNaN(variant)) {
                        $.ajax({
                            url: '/cart/add.js',
                            method: 'POST',
                            async: false,
                            data: { id: variant, quantity: 1, properties: property },
                            dataType: 'JSON',
                            success: function (result) {

                                $.ajax({
                                    url: '/cart/update.js',
                                    method: 'POST',
                                    async: false,
                                    data: { note: cartNotes },
                                    dataType: 'JSON',
                                    success: function (response) {
                                        setTimeout(function () {
                                            btn.removeClass('buy-loading');
                                        }, 2000);

                                        if (!btn.hasClass('custom_addToCheckout')) {
                                            btn.next('.btn')[0].click();
                                        } else {
                                            $.ajax({
                                                url: '/cart/add.js',
                                                method: 'POST',
                                                async: false,
                                                data: $('form[action="/cart/add"]').serialize(),
                                                dataType: 'JSON',
                                                success: function (result) {
                                                    window.location.href = '/checkout';
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                        });
                    }

                } else {
                    $('#embroidery_field')[0].reportValidity();
                }

            } else {
                if (!btn.hasClass('custom_addToCheckout')) {
                    btn.next('.btn')[0].click();
                    setTimeout(function () {
                        btn.removeClass('buy-loading');
                    }, 2000);
                } else {
                    $('.shopify-payment-button:not(.custom_addToCheckout) .shopify-payment-button__button')[0].click();
                }
            }
        });
    }

    $.getJSON('/cart.js', function (cart) {
        if (cart.note != null && cart.note != '') {
            if (cart.note.includes('/ Bordado:')) {
                var items = cart.items,
                    hasProdBordado = false;

                items.forEach(function(item) {
                    if (item.handle == 'bordado') {
                        hasProdBordado = true;
                    }
                });

                setTimeout(function () {
                    if (hasProdBordado == false) {
                        $.post('/cart/update.js', { note: null });

                        if ($('#cartSpecialInstructions').length) {
                            $('#cartSpecialInstructions').val('');
                        }
                    }
                }, 100);
            }
        }
    });
});